module.exports = __webpack_public_path__ + "static/img/pay-icon.1faa7025.svg";